'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _dataProvider = require('@wh/data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * CAS Client
 */
var CasClient = function () {
    function CasClient(casUrl, service) {
        var tunnel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dataProvider.defaultTunnel;
        (0, _classCallCheck3.default)(this, CasClient);

        this.casUrl = casUrl;
        this.service = service;
        this.tunnel = tunnel;
    }

    (0, _createClass3.default)(CasClient, [{
        key: 'setTunnel',
        value: function setTunnel(tunnel) {
            this.tunnel = tunnel;
        }
    }, {
        key: 'setAcceptedLanguage',
        value: function setAcceptedLanguage(language) {
            if (typeof language !== 'string') {
                throw new Error('Language must be a string');
            }
            this.acceptedLanguage = language;
        }
    }, {
        key: 'init',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var gateway = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var custLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var options, initUrl, response;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                options = {
                                    method: 'GET',
                                    headers: {
                                        Accept: 'application/json'
                                    },
                                    credentials: 'include'
                                };
                                initUrl = this.casUrl + '?service=' + encodeURIComponent(this.service) + ('&gateway=' + gateway.toString());


                                if (custLogin) {
                                    initUrl += '&cust_login=true';
                                }

                                _context.next = 5;
                                return (0, _dataProvider2.default)(initUrl, this.tunnel, options);

                            case 5:
                                response = _context.sent;

                                if (!response.success) {
                                    _context.next = 8;
                                    break;
                                }

                                return _context.abrupt('return', {
                                    next: response.next,
                                    tempPassword: response.tempPassword,
                                    serviceTicket: response.serviceTicket
                                });

                            case 8:
                                return _context.abrupt('return', _promise2.default.reject());

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function init() {
                return _ref.apply(this, arguments);
            }

            return init;
        }()
    }, {
        key: 'getFormDefaults',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                var options, initFormUrl, response, defaults, formDefaults;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                options = {
                                    method: 'GET',
                                    headers: {
                                        Accept: 'application/json'
                                    },
                                    credentials: 'include'
                                };
                                initFormUrl = this.casUrl + '?service=' + encodeURIComponent(this.service) + '&cust_login=true';
                                _context2.next = 4;
                                return (0, _dataProvider2.default)(initFormUrl, this.tunnel, options);

                            case 4:
                                response = _context2.sent;

                                if (!response.form_defaults) {
                                    _context2.next = 12;
                                    break;
                                }

                                defaults = response.form_defaults;

                                /* eslint-disable no-underscore-dangle */

                                this.executionKey = defaults.executionKey;
                                this.loginTicket = defaults.lt;
                                this.eventId = defaults._eventId;
                                /* eslint-enable no-underscore-dangle */

                                formDefaults = {
                                    username: defaults.username,
                                    password: defaults.password,
                                    rememberUsername: defaults.rememberUsername,
                                    keepMeLoggedIn: defaults.keepMeLoggedIn
                                };
                                return _context2.abrupt('return', {
                                    form_defaults: formDefaults,
                                    recoverLoginUrl: response.recoverLoginUrl
                                });

                            case 12:
                                if (!response.success) {
                                    _context2.next = 14;
                                    break;
                                }

                                return _context2.abrupt('return', _promise2.default.reject({
                                    next: response.next,
                                    tempPassword: response.tempPassword,
                                    serviceTicket: response.serviceTicket
                                }));

                            case 14:
                                return _context2.abrupt('return', _promise2.default.reject());

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getFormDefaults() {
                return _ref2.apply(this, arguments);
            }

            return getFormDefaults;
        }()
    }, {
        key: 'login',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(username, password, rememberMe, rememberUsername) {
                var formData, options, loginUrl, response;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                formData = {
                                    lt: this.loginTicket,
                                    username: username,
                                    password: password,
                                    rememberMe: rememberMe,
                                    rememberUsername: rememberUsername,
                                    _rememberUsername: this.switchValueToString(rememberUsername),
                                    _rememberMe: this.switchValueToString(rememberMe),
                                    _eventId: this.eventId,
                                    execution: this.executionKey
                                };
                                options = {
                                    method: 'POST',
                                    headers: {
                                        Accept: 'application/json',
                                        'Content-Type': 'application/x-www-form-urlencoded',
                                        'Accept-Language': this.acceptedLanguage
                                    },
                                    body: _querystring2.default.stringify(formData),
                                    credentials: 'include'
                                };
                                loginUrl = this.casUrl + '?service=' + encodeURIComponent(this.service) + '&cust_login=true';
                                _context3.next = 5;
                                return (0, _dataProvider2.default)(loginUrl, this.tunnel, options);

                            case 5:
                                response = _context3.sent;

                                if (!response.success) {
                                    _context3.next = 8;
                                    break;
                                }

                                return _context3.abrupt('return', {
                                    next: response.next,
                                    tempPassword: response.tempPassword,
                                    serviceTicket: response.serviceTicket
                                });

                            case 8:
                                return _context3.abrupt('return', _promise2.default.reject(response));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function login(_x4, _x5, _x6, _x7) {
                return _ref3.apply(this, arguments);
            }

            return login;
        }()
    }, {
        key: 'switchValueToString',
        value: function switchValueToString(switchValue) {
            return switchValue ? 'on' : 'off';
        }
    }]);
    return CasClient;
}();

exports.default = CasClient;
//# sourceMappingURL=cas-client.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/auth-client-component/dist/main/cas-client.js
// module id = 440
// module chunks = 0